import {
  TabGroup,
  Typography,
  Paper,
  ToggleButtonGroup,
  ToggleButton,
  Divider
} from '@sanlam-glacier/app-common/components';
import styles from './my-practice.module.scss';
import Regulation28Tab from '../organisms/regulation-28-tab/Regulation28Tab';
import { BreakpointProvider } from 'providers/breakpoint/BreakpointProvider';
import Section14Tab from '../organisms/section-14-tab/Section14Tab';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { MyPracticeToggleTabsKeys } from 'modules/my-practice/types/section-14/section-14.enums';

const MyPracticePage = () => {
  const [section14RenewalsCount, setSection14RenewalsCount] = useState<number | null>(null);
  const [reg28BreachesCount, setReg28BreachesCount] = useState<number | null>(null);
  const [selectedToggleTab, setSelectedToggleTab] = useState<MyPracticeToggleTabsKeys>();

  const renderBadgeCount = (count: number | null) => {
    if (count === null) return undefined;
    return {
      badgeContent: count,
      max: 99,
      className: clsx(styles.badgeCount)
    };
  };

  useEffect(() => {
    setSelectedToggleTab(MyPracticeToggleTabsKeys.practiceManagement);
  }, []);
  return (
    <BreakpointProvider>
      <div className={styles.container}>
        <Typography variant={Typography.VARIANT.H2} weight={Typography.WEIGHT.BOLD}>
          My practice
        </Typography>

        <ToggleButtonGroup
          exclusive={true}
          selected={[MyPracticeToggleTabsKeys.practiceManagement]}
          size={ToggleButtonGroup.SIZE.LARGE}
          className={styles.myPracticeToggleTabs}
          onChange={(value) => {
            const toggleTabValue = Array.isArray(value) ? value.join(',') : value;

            Object.values(MyPracticeToggleTabsKeys).includes(
              toggleTabValue as MyPracticeToggleTabsKeys
            ) && setSelectedToggleTab(toggleTabValue as MyPracticeToggleTabsKeys);
          }}
        >
          <>
            <ToggleButton
              aria-label='Practice management'
              value={MyPracticeToggleTabsKeys.practiceManagement}
              className={clsx(
                selectedToggleTab === MyPracticeToggleTabsKeys.practiceManagement &&
                  styles.showAsSelectedToggleTab
              )}
            >
              Practice management
            </ToggleButton>
            <ToggleButton
              aria-label='Future Tab'
              disabled
              value={MyPracticeToggleTabsKeys.futureTab1}
              className={clsx(
                selectedToggleTab === MyPracticeToggleTabsKeys.futureTab1 &&
                  styles.showAsSelectedToggleTab,
                styles.hiddenFutureTab
              )}
            >
              Future Tab
            </ToggleButton>
            <ToggleButton
              aria-label='Future Tab'
              disabled
              value={MyPracticeToggleTabsKeys.futureTab2}
              className={clsx(
                selectedToggleTab === MyPracticeToggleTabsKeys.futureTab2 &&
                  styles.showAsSelectedToggleTab,
                styles.hiddenFutureTab
              )}
            >
              Future Tab
            </ToggleButton>
            <ToggleButton
              aria-label='Future Tab'
              disabled
              value={MyPracticeToggleTabsKeys.futureTab3}
              className={clsx(
                selectedToggleTab === MyPracticeToggleTabsKeys.futureTab3 &&
                  styles.showAsSelectedToggleTab,
                styles.hiddenFutureTab
              )}
            >
              Future Tab
            </ToggleButton>
          </>
        </ToggleButtonGroup>

        <Paper className={styles.tabContainer}>
          <Divider className={styles.tabUnderline} />
          <div className={styles.tabHeaderSection}>
            <TabGroup
              panelPadding
              position={TabGroup.POSITION.LEFT}
              className={styles.tabs}
              tabs={[
                {
                  badgeProps: renderBadgeCount(section14RenewalsCount),
                  content: <Section14Tab onCountChange={setSection14RenewalsCount} />,
                  label: 'Section 14 fee renewals',
                  name: 'Section14'
                },
                {
                  badgeProps: renderBadgeCount(reg28BreachesCount),
                  content: <Regulation28Tab onCountChange={setReg28BreachesCount} />,
                  label: 'Regulation 28',
                  name: 'Regulation28'
                }
              ]}
            />
          </div>
        </Paper>
      </div>
    </BreakpointProvider>
  );
};

export default MyPracticePage;
